    export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="text-center text-sm text-gray-500 mt-8 py-4">
        Powered by Dentulu Inc © {currentYear} —
        <a href="https://www.dentulu.com" className="text-blue-600 hover:underline mx-1">www.dentulu.com</a> |
        <a href="https://www.dentulupro.com" className="text-blue-600 hover:underline mx-1">www.dentulupro.com</a> |
        <a href="mailto:support@dentulu.com" className="text-blue-600 hover:underline mx-1">support@dentulu.com</a> |
        <span className="mx-1">888-905-0226</span>
        </footer>
    );
    }
